import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import SettingsView from '../views/SettingsView.vue';
import ColorGuideView from "../views/ColorGuideView.vue";
import FeedbackView from "../views/FeedbackView.vue";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/location/:lat/:lng',
    name: 'LocationDetail',
    component: HomeView,
    props: true, // This allows route params to be passed as props to the component
  },
  {
    path: '/settings',
    name: 'Settings',
    component: SettingsView
  },
  {
    path: '/color-guide',
    name: 'ColorGuide',
    component: ColorGuideView
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: FeedbackView
  },
  {
    path: '/pwa-install-guide',
    name: 'PWAInstallGuide',
    component: () => import('../views/PWAInstallGuideView.vue')
  },
  {
    path: '/legal/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/legal/PrivacyPolicyView.vue')
  },
  {
    path: '/legal/terms-of-service',
    name: 'TermsOfService',
    component: () => import('../views/legal/TermsOfServiceView.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
